import Seo from '../components/Seo';
import InquiryForm from '../components/InquiryForm';
import { brand } from '../config/brand';

export default function ContactPage() {
  return (
    <>
      <Seo title="Contact Us" description="Get in touch for quotes, samples, or partnerships." />

      <section className="container-page grid gap-10 py-14 md:grid-cols-2">
        <div>
          <h1 className="font-display text-4xl font-bold">Contact Uclipse</h1>
          <p className="mt-3 text-slate-600">
            We respond to enquiries within 1 business day. For bulk orders, share quantity and delivery city.
          </p>

          <dl className="mt-8 space-y-5 text-sm">
            <div>
              <dt className="font-semibold uppercase tracking-wide text-slate-500">Address</dt>
              <dd className="mt-1 text-slate-800">
                {brand.address.line1}<br />
                {brand.address.line2}<br />
                {brand.address.city}, {brand.address.state} {brand.address.postalCode}
              </dd>
            </div>
            <div>
              <dt className="font-semibold uppercase tracking-wide text-slate-500">Phone</dt>
              <dd className="mt-1">
                <a href={`tel:${brand.phone.replace(/\s|-/g, '')}`} className="text-brand-600 hover:underline">
                  {brand.phone}
                </a>
              </dd>
            </div>
            <div>
              <dt className="font-semibold uppercase tracking-wide text-slate-500">Email</dt>
              <dd className="mt-1">
                <a href={`mailto:${brand.email}`} className="text-brand-600 hover:underline">{brand.email}</a>
              </dd>
            </div>
            <div>
              <dt className="font-semibold uppercase tracking-wide text-slate-500">Udyam Reg No</dt>
              <dd className="mt-1 text-slate-800">{brand.udyam}</dd>
            </div>
          </dl>
        </div>

        <InquiryForm type="contact" title="Send us a message" />
      </section>
    </>
  );
}
